import { useMemo } from 'react'
import creditStatusMapping from '../../../Mapping/creditStatusMapping'
import returnRequestStatusMapping from '../../../Mapping/returnRequestStatusMapping'

const useReturnStatusData = props => {
  const {
    orderInfo = {},
    returnRequest = {},
    returnRequestStatus: mainReturnRequestStatus,
    creditStatus: mainCreditStatus,
  } = { ...props }

  return useMemo(() => {
    const { merchantOrderId, emailAddress, orderId } = { ...orderInfo }
    let messageData = {}

    const {
      credit_status_code: creditStatusCode,
      order_item_id: orderItemId,
      credit_id: creditId,
      credit_status: creditStatus,
      rma_id: rmaId,
      return_request_id: returnRequestId,
      return_request_status: returnRequestStatus,
    } = { ...returnRequest }

    if (creditStatus) {
      messageData = creditStatusMapping(creditStatusCode, mainCreditStatus)

      return {
        message: (messageData && messageData.main_reason) || null,
        idType: 'Credit ID:',
        rmaId,
        orderItemId,
        orderId,
        merchantOrderId,
        email: emailAddress,
        creditId,
      }
    }

    // Priority: Display RMA ID
    if (typeof returnRequest !== 'undefined'
        && returnRequest.rma_id) {
      return {
        message: (messageData && messageData.main_reason) || null,
        idType: 'RMA ID:',
        rmaId,
        orderItemId,
        orderId,
        merchantOrderId,
        email: emailAddress,
        creditId,
      }
    }

    // Display Return Request ID
    if (typeof returnRequest !== 'undefined' && returnRequest.return_request_id !== '') {
      messageData = returnRequestStatusMapping(returnRequestStatus, mainReturnRequestStatus)

      return {
        message: (messageData && messageData.main_reason) || null,
        idType: 'Return Request ID:',
        returnRequestId,
        merchantOrderId,
        email: emailAddress,
        orderId,
        orderItemId,
      }
    }

    return null
  }, [orderInfo, returnRequest, mainReturnRequestStatus])
}

export default useReturnStatusData
